import { HugeiconsIcon } from "@hugeicons/react";
import { PlusSignIcon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import {
  BrandDrawer,
  BrandTable,
  useBrandList,
  useBrandStore,
} from "@/features/brand";

export default function BrandsPage() {
  const openDrawerForAdd = useBrandStore((s) => s.openDrawerForAdd);
  const { data, isLoading, error } = useBrandList();

  return (
    <div className="flex h-full flex-col bg-slate-50/50 p-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900">브랜드 관리</h1>
          <p className="mt-0.5 text-xs text-gray-600">
            브랜드별 도메인, 사업자 정보, 노출 자산을 관리합니다
          </p>
        </div>
        <Button
          size="sm"
          onClick={openDrawerForAdd}
          className="bg-blue-600 px-3 py-1.5 text-sm font-bold hover:bg-blue-700"
        >
          <HugeiconsIcon icon={PlusSignIcon} size={14} className="mr-1.5" />
          신규 등록
        </Button>
      </div>

      <BrandTable data={data} isLoading={isLoading} error={error} />

      <BrandDrawer />
    </div>
  );
}
